<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div
        class="page-header login-page header-filter"
        filter-color="black"
        style="
          background-image: url('https://www.unigre.it/sites/it/cache/file/D2C5AD09-D155-453A-A18A1475FAD12E18_homeslider.jpg');
          background-size: cover;
          background-position: top center;
        "
      >
        <!-- {{$store.state.parametri }} -->

        <v-container fluid>
          <center></center>
          <section>
            <div class="container">
              <div
                class="row d-flex justify-content-center align-items-center h-100"
              >
                <!--lingua-->

                <!--fine-->

                <div class="col-xl-16 pa-2" v-if="getStatoAPI">
                  <div class="card rounded-3 text-black">
                    <div class="row g-0">
                      <div
                        class="col-lg-6 d-flex align-items-center gradient-custom-2"
                      >
                        <div
                          class="text-white px-3 py-4 p-md-5 mx-md-4 text-center"
                        >
                          <h3 class="mb-4">ATTENZIONE!</h3>
                          <p class="small mb-0 h4 text-center">
                            Accesso riservato solo agli operatori di Segreteria
                          </p>
                          <v-divider style="font: white"></v-divider>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="card-body p-md-4 mx-md-4">
                          <div class="text-center">
                            <!--<img
                              src="https://www.unigre.it/sites/it/cache/file/9CDD74F1-88AD-4FFF-81227E23BD0F52F7.svg"
                              style="width: 100px"
                              alt="logo"
                            />-->
                            <br /><br />
                          </div>

                          <v-form
                            ref="form"
                            @submit.prevent="onSubmit"
                            v-model="valid"
                            lazy-validation
                          >
                            <div
                              class="card card-nav-tabs animate__animated animate__bounceInDown"
                            >
                              <h4
                                class="card-header card-header-primary font-weight-bold grey lighten-2 black--text text--lighten-1 titolocard"
                              >
                                Gestione Immatricolazione
                              </h4>

                              <div class="card-body">
                                <h4 class="card-title"></h4>

                                <div class="text-center">
                                  <span class="bmd-form-group">
                                    <div class="input-group">
                                      <v-text-field
                                        prepend-icon="mdi-numeric"
                                        v-model="form.matricola"
                                        label="N° Prematricola"
                                        :rules="[rules.required, rules.numeri]"
                                      ></v-text-field>
                                      <v-text-field
                                        prepend-icon="mdi-account"
                                        v-model="form.utente"
                                        label="Utente"
                                        :rules="[rules.required]"
                                      ></v-text-field>
                                    </div>
                                  </span>
                                  <span class="bmd-form-group">
                                    <div class="input-group">
                                      <v-text-field
                                        prepend-icon="mdi-lock"
                                        v-model="form.password"
                                        label="Password"
                                        :type="value ? 'password' : 'text'"
                                        :rules="[
                                          (v) => !!v || $t('campoObbligatorio'),
                                        ]"
                                        :append-icon="
                                          value ? 'mdi-eye' : 'mdi-eye-off'
                                        "
                                        @click:append="() => (value = !value)"
                                      ></v-text-field>
                                    </div>
                                  </span>
                                </div>
                              </div>

                              <v-alert
                                v-if="authErr"
                                class="pa-2 ma-2"
                                type="error"
                              >
                                {{ $t("login.loginErrato") }}</v-alert
                              >
                              <div class="card-footer justify-content-center">
                                <v-btn
                                  class="btn btn-action darken-2 white--text"
                                  @click="checkLogin"
                                >
                                  {{ $t("login.accedi") }}
                                </v-btn>
                                <!--<a
                                  class="
                                    text-muted
                                    card-footer
                                    justify-content-center
                                  "
                                  href="#!"
                                  @click="recuperoPassword=true"
                                  >Password dimenticata?</a
                                >-->
                              </div>
                            </div>
                            <v-divider></v-divider>
                          </v-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="pa-2">
                  <v-alert
                    color="primary"
                    dark
                    icon=" mdi-monitor-lock"
                    border="left"
                    prominent
                    class="text-h6"
                  >
                    {{ $t("chiuse") }}
                  </v-alert>
                  <!--<v-card color="primary">
                    <v-card-title class="text-h5 darken-2 white--text">
                      <v-icon large color="white darken-2" class="pa-1">
                        mdi-monitor-lock
                      </v-icon>

                      {{ $t("chiuse") }}
                    </v-card-title>
                  </v-card>-->
                </div>
              </div>
            </div>
          </section>
          <p class="text-center text-overline">
            &copy;Istituto Patristico Augustinianum - V.1.0
          </p>
        </v-container>
      </div>

      <keep-alive>
        <nuovo-utente
          :attivo="nuovoUtente"
          @chiudiForm="chiudiForm"
        ></nuovo-utente>
      </keep-alive>

      <recupero-password
        :attivo="recuperoPassword"
        @chiudiForm="chiudiForm"
      ></recupero-password>

      <!-- fine form 
      <footer class="footer">
        <div class="container">
          <nav class="float-left">
            <ul>
              <li>
                <a href="https://www.unigre.it">
                 
                </a>
              </li>
            </ul>
          </nav>
          <div class="copyright float-right">&copy; PUG</div>
        </div>
      </footer>-->
    </div>
  </div>
</template>

<script>
//import { mapActions } from "vuex";
//import axios from "axios";
import api from "@/services/EventService.js";
import nuovoUtente from "@/components/nuovoUtente.vue";
import recuperoPassword from "@/components/recuperoPassword.vue";

export default {
  name: "Login",

  components: { nuovoUtente, recuperoPassword },

  data() {
    return {
      value: true,
      authErr: false,
      statoAPI: true,
      nuovoUtente: false,
      recuperoPassword: false,
      form: {
        matricola: "",
        utente: "",
        password: "",
      },
      showError: false,
      rules: {
        required: (value) => {
          return !!value || this.$i18n.t("campoObbligatorio");
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$i18n.t("login.emailNonValida");
        },
        numeri: (value) => {
          const pattern = /^\d+$/;
          return pattern.test(value) || "Inserire solo numeri";
        },
      },
    };
  },
  mounted() {
    this.$store.commit("resetSessione");
    this.checkAlive();
  },
  computed: {
    getStatoAPI: {
      get: function() {
        return this.$store.state.statoWS;
      },
    },
  },

  methods: {
    goRinnovi() {
      window.location.href = "https://rinnovi-segreteria.unigre.it";
    },
    lingua(flag) {
      this.$i18n.locale = flag;
    },

    chiudiForm() {
      this.nuovoUtente = false;
      this.recuperoPassword = false;
    },
    async checkAlive() {
      api
        .get("CheckAlive/immatricolazioni")
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.statoWS = true;
          } else {
            this.$store.state.statoWS = false;
          }
        })
        .catch(function() {
          this.$store.state.statoWS = false;
        });
    },

    async esitoLogin(esito) {
      //alert(JSON.stringify(esito));
      if (esito.status == 200) {
        //alert("OK:" + JSON.stringify(esito));
        this.$store.state.parametri = esito.data;

        if (
          //esito.data.statoDomanda == "PRESENTATA" ||
          //esito.data.statoDomanda == "BOZZA" ||
          esito.data.statoDomanda == "IN LAVORAZIONE"
        ) {
          this.$store.dispatch("recuperoDatiDBEvent");
          this.$router.push("/immatricolazioni");
        } else {
          this.$swal.fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",
            cancelButtonClass: "primary darken-1",
            title: "ATTENZIONE",
            text:
              "Per poter essere modificata, la richiesta deve trovarsi nello stato 'IN LAVORAZIONE'",
            //text: this.$t("salvaDati.fine.testo"),
            //text: JSON.stringify(this.$store.getters.riepilogoGenerale),
            icon: "warning",
            confirmButtonText: "OK",
          });
        }

        this.authErr = false;
      } else {
        //alert("Errore:" + JSON.stringify(esito));

        this.$swal
          .fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",
            cancelButtonClass: "primary darken-1",
            title: "ATTENZIONE",
            text: esito.data,
            //text: JSON.stringify(this.$store.getters.riepilogoGenerale),
            icon: "warning",
            confirmButtonText: "OK",
          })
          .then(function() {
            location.reload();
          });

        //this.authErr = true;
        this.$store.state.parametri = null;
      }
    },

    async checkLogin() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("LogInSegreteria", this.form)
          .then((r) => this.esitoLogin(r));
        /*.catch(() =>
              //alert(JSON.stringify(err))
              //this.authErr = true
            )*/
      }
    },
  },
};
</script>

<style scope>
.testopiccolo {
  font-size: 11px;
}

.titolocard {
  font-size: 20px;
  color: black;
}

.gradient-custom-2 {
  /* fallback for old browsers */
  background: #a43b54;

  /* Chrome 10-25, Safari 5.1-6 
  background: -webkit-linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);*/

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ 
  background: linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);*/
}

@media (min-width: 768px) {
  .gradient-form {
    height: 100vh !important;
  }
}
@media (min-width: 769px) {
  .gradient-custom-2 {
    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }
}
</style>
